import React from 'react';
import PropTypes from 'prop-types';

import OtherBenefitsPanels from './OtherBenefitsPanels';
import '../saleslogic.css';
import { Title } from '../styles';
import '../../../../../../grid.css';

const OtherBenefits = (props) => {
    const {
        resiToggle, provider, projectState, firstName, smartValue,
        annualResults, systemSize, inverter, includeESS,
    } = props;

    const terms = {
        provider,
        projectState,
        firstName,
        resiToggle,
        smartValue,
        annualResults,
        systemSize,
        inverter,
        includeESS,
    };

    return (
        <div>
            <Title>More Solar Benefits</Title>
            <OtherBenefitsPanels terms={terms} />
        </div>
    );
};

OtherBenefits.propTypes = {
    resiToggle: PropTypes.bool.isRequired,
    includeESS: PropTypes.bool.isRequired,
    annualResults: PropTypes.object.isRequired,
    provider: PropTypes.number.isRequired,
    projectState: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    smartValue: PropTypes.number.isRequired,
    systemSize: PropTypes.number.isRequired,
    inverter: PropTypes.string.isRequired,
};

export default OtherBenefits;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/OtherBenefits/OtherBenefits.js